export default {
  /**单聊*/
  C2C: 1,
  /**群聊*/
  GROUP: 2,
};
